// Home.tsx
import React from 'react';
import styles from './Home.module.css';
import webmVideo from '../../assets/videos/HomePageVid_compressed.webm';
import ep1Image from '../../assets/images/mobdrama_ep.jpg';
import ep2Image from '../../assets/images/mobdrama_ep2.jpg';
import appleMusicLogo from '../../assets/images/AppleMusic.png';
import spotifyLogo from '../../assets/images/spotifylogo.png';
import show1Image from '../../assets/images/show1.jpg'; // Example show image
import show2Image from '../../assets/images/show2.jpg'; // Example show image

const Home: React.FC = () => {
    return (
        <div className={styles.home}>
            <div className={styles.videoContainer}>
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    className={styles.videoBackground}
                >
                    <source src={webmVideo} type="video/webm" />
                    Your browser does not support the video tag.
                </video>
                <div className={styles.content}>
                    <h1>Welcome to Mob Drama</h1>
                    <h3>Official website for Mob Drama</h3>
                </div>
            </div>
            <div className={styles.upcomingShowsContainer}>
                <h2>UPCOMING SHOWS</h2>
                <div className={styles.show}>
                    <h3>July 31</h3>
                    <img src={show1Image} alt="Show 1" className={styles.showImage} width="772" height="1000" loading="lazy" />
                    <a href="https://www.ticketweb.com/event/official-claire-the-omnitones-burlington-bar-tickets/13747573?pl=mp" className={styles.waveEffect}>
                        CLICK TO BUY TICKETS
                    </a>
                </div>
                <div className={styles.show}>
                    <h3>September 28</h3>
                    <img src={show2Image} alt="Show 2" className={styles.showImage} width="750" height="1000" />
                    {/* <a href="https://www.ticketweb.com/event/official-claire-the-omnitones-burlington-bar-tickets/13747573?pl=mp" className={styles.waveEffect}>
                        CLICK TO BUY TICKETS
                    </a> */}
                </div>
            </div>
            <div className={styles.episodeContainer}>
                <div className={styles.episode}>
                    <h2>Mob Drama EP</h2>
                    <img src={ep1Image} alt="Mob Drama EP" className={styles.episodeImage} />
                    <div className={styles.platforms}>
                        <a href="https://music.apple.com/us/album/mob-drama-ep/1737552600" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={appleMusicLogo} alt="Apple Music" className={styles.platformLogo} />
                        </a>
                        <a href="https://open.spotify.com/album/5V4LJZLkA1bjtFZOHs02sP?si=jupMWU6sQGGf9LX4c4kFjQ" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={spotifyLogo} alt="Spotify" className={styles.platformLogo} />
                        </a>
                    </div>
                </div>
                <div className={styles.episode}>
                    <h2>Mob Drama EP II</h2>
                    <img src={ep2Image} alt="Mob Drama EP II" className={styles.episodeImage} />
                    <div className={styles.platforms}>
                        <a href="https://music.apple.com/us/album/mob-drama-ii-ep/1737552423" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={appleMusicLogo} alt="Apple Music" className={styles.platformLogo} />
                        </a>
                        <a href="https://open.spotify.com/album/66ZuJBbNY04GqbW7kdcuw2?si=V42aiU58RMShv1M-msAoig" target="_blank" rel="noopener noreferrer" className={styles.waveEffect}>
                            <img src={spotifyLogo} alt="Spotify" className={styles.platformLogo} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
